import { Section } from './Section.jsx';
import { T } from '../T.jsx';

// The signed-in hero swaps the two CTA buttons for a welcome banner. The old
// page did this by rewriting .hero-cta's outerHTML from the auth code, which is
// why the section loader had to call back into it (`window._renderUserUI`) once
// the hero markup existed. Here it is just a branch.
function firstNameOf(user) {
  const displayName = user.name || user.email || '';
  const first = displayName.split(/[\s@]/)[0] || '';
  return first.charAt(0).toUpperCase() + first.slice(1);
}

export function Hero({ user }) {
  return (
    <Section>
      <section className="hero" id="hero">
        <T k="ml_hero_badge" as="div" className="hero-badge">
          Intelligent Lecture Platform
        </T>
        <h1>
          <span className="hero-title-text">MyLecture</span>
        </h1>
        <T k="ml_hero_tagline" as="p" className="hero-subtitle">
          Create. Present. Engage.
        </T>
        <T k="ml_hero_desc" as="p" className="hero-desc">
          The next-generation lecture platform that empowers educators to build beautiful
          presentations, deliver engaging live sessions, and harness AI to transform how
          knowledge is shared in the classroom.
        </T>

        {user ? (
          <div className="hero-welcome">
            {/* Untranslated on purpose: the name is dynamic, and <T> may only wrap
                text that never changes — see the contract in components/T.jsx. */}
            <span className="welcome-greeting">Welcome back, {firstNameOf(user)}!</span>
            <div className="welcome-actions">
              <a href="/dashboard.html" className="wa-dashboard">My Dashboard</a>
              <a href="#examples" className="wa-browse">Browse LiveDecks</a>
            </div>
          </div>
        ) : (
          <div className="hero-cta">
            <T k="ml_hero_get_started" as="a" href="#cta" className="btn btn-hero-primary">
              Get Started
            </T>
            <T k="ml_hero_watch_demo" as="a" href="#workflow" className="btn btn-hero-secondary">
              Watch Demo
            </T>
          </div>
        )}

        <div className="hero-pillars">
          <span className="hero-pill">
            <span className="pip" style={{ background: 'var(--accent-e)' }} />{' '}
            <T k="ml_pill_slides">Slide Creation</T>
          </span>
          <span className="hero-pill">
            <span className="pip" style={{ background: 'var(--accent-d)' }} />{' '}
            <T k="ml_pill_live">Live Presentation</T>
          </span>
          <span className="hero-pill">
            <span className="pip" style={{ background: 'var(--accent-i2)' }} />{' '}
            <T k="ml_pill_ai">AI Assistance</T>
          </span>
        </div>

        <div className="hero-scroll">
          <span>Scroll</span>
          <div className="scroll-line" />
        </div>
      </section>
    </Section>
  );
}
